// ./src/components/features/ContentBlocks/ContentTypeBadge/ContentTypeBadge.tsx
import React from "react";
import { Badge, Group } from "@mantine/core";
import { AppIcon } from "@/components/generic";

export interface ContentTypeBadgeProps {
  type?: string | undefined | null;
}

const contentTypes: any = {
  IMAGE: { icon: "Photo", color: "green", label: "Image" },
  VIDEO: { icon: "Video", color: "purple", label: "Video" },
  EXTERNAL_VIDEO: { icon: "Video", color: "purple", label: "External Video" },
  HTML: { icon: "Code", color: "orange", label: "HTML" },
  IFRAME: { icon: "Frame", color: "orange", label: "HTML" },
  MARKDOWN: { icon: "FileText", color: "teal", label: "Markdown" },
  CLOCK: { icon: "Clock", color: "blue", label: "Clock" },
  COUNTDOWN: { icon: "TrendingDown", color: "blue", label: "Countdown" },
  COUNTUP: { icon: "TrendingUp", color: "blue", label: "Countup" },
  CALENDAR: { icon: "Calendar", color: "blue", label: "Calendar" },
  MESSAGE: { icon: "Message", color: "blue", label: "Message" },
  UNKNOWN: { icon: "File", color: "gray", label: "Unknown" },
};

export const ContentTypeBadge: React.FC<ContentTypeBadgeProps> = ({ type }) => {
  const typeInfo =
    contentTypes[type != null ? type : "UNKNOWN"] || contentTypes["UNKNOWN"];

  return (
    <Badge color={typeInfo.color} variant="outline" size="md">
      <Group gap={4} align="center" style={{ flexWrap: "nowrap" }}>
        <AppIcon iconName={typeInfo.icon as any} size={16} />
        <span>{typeInfo.label}</span>
      </Group>
    </Badge>
  );
};
